import React, { useState } from 'react';
import './TeamsBotTestPage.css';

export default function TeamsBotTestPage() {
  const botAppId = 'c184a2ca-0860-4704-803b-55d5a4f86fb2';
  const [status, setStatus] = useState('Open de bot direct in Teams via de knop hieronder.');

  const openTeams = () => {
    // Open a direct 1:1 chat with the bot identity in Teams.
    const teamsBotChatLink = `https://teams.microsoft.com/l/chat/0/0?users=28:${botAppId}`;
    const popup = window.open(teamsBotChatLink, '_blank', 'noopener,noreferrer');
    if (!popup) {
      setStatus('Kon Teams niet openen (popup geblokkeerd). Sta popups toe en probeer opnieuw.');
      return;
    }
    setStatus('Teams geopend met bot-chat deep link. Als Teams een fout toont: controleer of de bot-app is toegevoegd/geïnstalleerd in Teams.');
  };

  return (
    <section className="v-teams-test">
      <header className="v-teams-test__header">
        <div>
          <h1>Teams Bot Test</h1>
          <p>Gebruik deze pagina om je bot direct in Microsoft Teams te openen.</p>
        </div>
        <button type="button" className="v-teams-test__btn v-teams-test__btn--ghost" onClick={openTeams}>
          Open Bot in Teams
        </button>
      </header>

      <div className="v-teams-test__panel">
        <p className="v-teams-test__status">{status}</p>
        <p className="v-teams-test__status">
          Als de chat niet opent: installeer/pin de bot in Teams App Catalog en controleer dat je in de juiste tenant bent ingelogd.
        </p>
      </div>
    </section>
  );
}
